<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab label='Process'>
    <mat-card class='mat-elevation-z8 job-information-card'>
      @if (job(); as selectedJob) {
        <fieldset class='job-information-title'>
          <legend>{{selectedJob.name}} - {{selectedJob.jobTaskTemplateName}}</legend>
        </fieldset>
        <app-gateway-details [(gateways)]='gateways'
          [job]='selectedJob'
          (jobChange)='job.set($event)'
          [exportStatus]="exportStatus()"
          (jobStartEnabled)='onJobStartStateChanged($event)'
          (exportCompleteEvent)='exportCompleteEvent.emit($event)' />
        <app-job-tasks [job]='selectedJob'
          [tasks]='tasks()'
          [(jobStartEnabled)]='jobStartEnabled' />
      }
    </mat-card>
  </mat-tab>
  <mat-tab label='Notifications'>
    <mat-card class='mat-elevation-z8 job-information-card'>
      <div class="job-information-notifications">
        <button
          class='job-information-clear-otap-notifications-button'
          mat-raised-button
          (click)='clearOtapNotifications()'
          color='accent'
          type='button'
          [attr.data-cy]="'clear-otap-notifications'">
          <span class='or-button-label'>Clear</span>
        </button>
        <mat-accordion class='otap-notification-headers-align' multi>
          @for (otapNotification of otapNotifications(); track otapNotification) {
            <div>
              <mat-expansion-panel [expanded]='true' hideToggle='true'>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ otapNotification.timestamp }}
                  </mat-panel-title>
                  <mat-panel-description>
                    {{ otapNotification.gateway }}
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <code>
                  <pre>{{ otapNotification.message }}</pre>
                </code>
              </mat-expansion-panel>
            </div>
          }
        </mat-accordion>
      </div>
    </mat-card>
  </mat-tab>
</mat-tab-group>
